export default "__VITE_ASSET__CSNtdKpg__"